import { createApi } from '@reduxjs/toolkit/query/react';

import { DeleteParamsDto, DeleteStatusDto, PaginatedResponse } from '../common/dto/common.dto';
import { FilterDto } from '../common/dto/filter.dto';
import { TemplateCreateInfo, TemplateDuplicateDto, TemplateUpdateInfo, TemplateUpsertDto, TemplateViewDto } from '../common/dto/template.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_DATA_COLLECTION_SERVICE;
const TAG_TYPE = 'Template';

export const templateApi = createApi({
  reducerPath: 'templateApi',
  baseQuery: customFetchBase(`${API_URI}/api/template`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    // getTemplatesList: builder.query<PaginatedResponse<TemplateViewDto>, ListCommonPayload>({
    //   query: (payload: ListCommonPayload) => {
    //     let query = 'template/?';
    //     if (payload.searchParam) query += `searchParam=${payload.searchParam}&`;
    //     if (payload.page) query += `page=${payload.page}&`;
    //     if (payload.limit) query += `limit=${payload.limit}&`;
    //     if (payload.disablePagination) query += `disablePagination=${payload.disablePagination}&`;
    //     if (payload.sortBy) query += `sortBy=${payload.sortBy}&`;
    //     if (payload.sortOrder) query += `sortOrder=${payload.sortOrder}`;
    //     return query;
    //   },
    //   providesTags: [TAG_TYPE],
    // }),
    searchTemplates: builder.mutation<PaginatedResponse<TemplateViewDto>, Partial<FilterDto>>({
      query(body) {
        return {
          url: ``,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    searchDropDownTemplates: builder.mutation<PaginatedResponse<TemplateViewDto>, Partial<{ locationIds: string[] }>>({
      query(body) {
        return {
          url: `dropdown-list`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    getTemplate: builder.query<TemplateViewDto, string>({
      query: (id: string) => {
        return `${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
    getTemplateForEdit: builder.query<TemplateViewDto, string>({
      query: (id: string) => {
        return `for-edit/${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
    getTemplateWithDeleted: builder.query<TemplateViewDto, string>({
      query: (id: string) => {
        return `with-deleted/${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
    getTemplateWithVersion: builder.query<TemplateViewDto, { id: string; version: string | null }>({
      query: ({ id, version }: { id: string; version: string }) => {
        return version ? `${id}/${version}` : `${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
    createTemplateInfo: builder.mutation<TemplateViewDto, Partial<TemplateCreateInfo>>({
      query(body) {
        return {
          url: ``,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    updateTemplateInfo: builder.mutation<TemplateViewDto, Partial<TemplateUpdateInfo>>({
      query(data) {
        return {
          url: ``,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    saveTemplateElements: builder.mutation<TemplateViewDto, TemplateUpsertDto>({
      query(data) {
        return {
          url: `elements`,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    duplicateTemplate: builder.mutation<TemplateViewDto, Partial<TemplateDuplicateDto>>({
      query(body) {
        return {
          url: `duplicate`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    deleteTemplate: builder.mutation<DeleteStatusDto, DeleteParamsDto>({
      query(data: DeleteParamsDto) {
        return {
          url: data.id,
          method: 'DELETE',
          body: data.params ?? {},
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const {
  useLazyGetTemplateQuery,
  useLazyGetTemplateForEditQuery,
  useLazyGetTemplateWithVersionQuery,
  useSaveTemplateElementsMutation,
  useCreateTemplateInfoMutation,
  useSearchTemplatesMutation,
  useDeleteTemplateMutation,
  useDuplicateTemplateMutation,
  useUpdateTemplateInfoMutation,
  useLazyGetTemplateWithDeletedQuery,
  useSearchDropDownTemplatesMutation,
} = templateApi;
